import { ref } from 'vue';
import http from './http';
import useUser from './useUser';

export default function () {
    const loading = ref(false);
    const showModal = ref(false);
    const eula = ref();
    const scrollbarRef = ref(null);

    const { onLogout } = useUser();

    async function read(anonymous = false) {
        loading.value = true;
        try {
            const url = anonymous ? '/api/site/eula' : '/api/app/eula/read';
            const res = await http.request("get", url);

            if (res.Type == 200 && res.Data != null) {
                eula.value = res.Data;
                showModal.value = true;
            }
            return false; 
        } finally {
            loading.value = false;
        }
    }

    async function onDecline() {
        await onLogout();
    }

    async function onAccept() {
        loading.value = true;
        try {
            const res = await http.request("post", "/api/app/eula/accept");
            if (res?.Type == 200) {
                showModal.value = false;
            }
        } finally {
            loading.value = false;
        }
    }

    return { loading, read, showModal, eula, scrollbarRef, onDecline, onAccept };
}